import { Component, Input } from '@angular/core';

import { ModalService } from '../modal.service';
import { AbstractModal } from '../AbstractModal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ls-message-modal',
  templateUrl: 'download-exception-modal.component.html'
})
export class DownloadExceptionModalComponent extends AbstractModal {
  @Input()
  public data: any;

  constructor(private modal: ModalService, private sanitizer: DomSanitizer) {
    super();
  }

  public close(message: string): void {
    this.modal.close(message);
  }

  public getDataUrl(sanitized: boolean): SafeResourceUrl | string {
    if (sanitized) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.data.safeUrl);
    }
    return this.data.safeUrl;
  }
}
